export enum RegistrationStep {
    'PersonalDetails',
    'ProfessionalDetails',
    'ContactDetails',
    'Identity',
    'Address',
}
